export enum UserDropdownKey {
  Profile = 'Profile',
  InternalApps = 'InternalApps',
  Settings = 'Settings',
  Logout = 'Logout',
  Export = 'Export',
  ApiTokens = 'ApiTokens',
}
